import { render, staticRenderFns } from "./Routine.vue?vue&type=template&id=8adf1c58&scoped=true"
import script from "./Routine.vue?vue&type=script&lang=js"
export * from "./Routine.vue?vue&type=script&lang=js"
import style0 from "./Routine.vue?vue&type=style&index=0&id=8adf1c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adf1c58",
  null
  
)

export default component.exports